import { render } from "./이념.vue?vue&type=template&id=0301b118&lang=true"
import script from "./이념.vue?vue&type=script&lang=js"
export * from "./이념.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__